module.exports = __webpack_public_path__ + "static/media/alphabackground2.080a1885.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/alphabackground2.jpg
// module id = 1647
// module chunks = 0